import compose from "lodash/fp/compose";
import setHours from "date-fns/fp/setHours";
import setMinutes from "date-fns/fp/setMinutes";
import subDays from "date-fns/fp/subDays";
import formatDateTime from "utils/formatDateTime";

export const createTicketAvailabilityDate = (
  eventDate: Date,
  time: string | null | undefined,
  days: number | null | undefined
): string | undefined => {
  if (!days) {
    return undefined;
  }

  const [hours, minutes] = time
    ?.split(":")
    .map((value) => Number.parseInt(value, 10)) || [0, 0];

  return formatDateTime(
    compose(subDays(days), setHours(hours), setMinutes(minutes))(eventDate)
  );
};
